import { Component } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent {
  username: string = '';
  email: string = '';
  password: string = '';
  confirmPassword: string = '';
  firstName: string = '';
  errorMessage: string = '';
  successMessage: string = '';
  isLoading: boolean = false;

  constructor(private authService: AuthService) {}

  onSubmit(): void {
    // Limpiar mensajes previos
    this.errorMessage = '';
    this.successMessage = '';

    // Validar que las contraseñas coincidan
    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Las contraseñas no coinciden.';
      return;
    }

    // Validar que todos los campos estén completos
    if (!this.username || !this.email || !this.password || !this.confirmPassword || !this.firstName) {
      this.errorMessage = 'Por favor complete todos los campos.';
      return;
    }

    this.isLoading = true;

    this.authService
      .signUp(this.username, this.email, this.password, this.confirmPassword, this.firstName)
      .then(() => {
        this.successMessage = 'Registro exitoso. Redirigiendo...';
        this.errorMessage = '';
        // Opcional: redirigir después de un tiempo
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      })
      .catch((error) => {
        this.errorMessage = error.error?.message || 'Error durante el registro. Inténtalo de nuevo.';
        this.successMessage = '';
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}